import {
  OneWaySlabInput,
  TwoWaySlabInput,
  BeamInput,
  ColumnInput,
  USAGE,
  SLAB_TYPE,
  FoundationInput,
  BasementWallInput,
  WindTunnelStudyInput,
} from './const'
import { $POST, ENDPOINT } from './requester'

/* API Response */
interface ResponseBase {
  statusCode: number
  errorMsg?: string
}

export interface SlabResponse extends ResponseBase {
  needThickness: number
}

export interface BeamResponse extends ResponseBase {
  needDepth: number
}

export interface ColumnResponse extends ResponseBase{
  needArea: number
  needAreaForLateral: number
  needDiameterForCircle: number
  criterionSize: number
  calculatedSize: number
  calculatedSizeForLateral: number
}

export interface FoundationResponse extends ResponseBase {
  needHeight: number
  finalRatio: number
  criterionSize: number
  calculatedSizeForLateral: number
}

export interface BasementWallResponse extends ResponseBase {
  thickness: number[]
}

export interface WindTunnelStudyResponse extends ResponseBase {
  criteria: number
  isNeedTesting: number
}

export const Query = {
  requestCalcOneWaySlab (payload: OneWaySlabInput) {
    return $POST<SlabResponse>(ENDPOINT.SLAB, {
      type: 1, // One-Way
      subType: SLAB_TYPE[payload.slabType],
      width: payload.beamSpan,
      height: payload.beamSpan,
    }, 'one-way-slab')
  },
  requestCalcTwoWaySlab (payload: TwoWaySlabInput) {
    return $POST<SlabResponse>(ENDPOINT.SLAB, {
      type: 2, // Two-Way
      width: payload.longSideSpan,
      height: payload.shortSideSpan,
    }, 'two-way-slab')
  },
  requestCalcBeam (payload: BeamInput) {
    return $POST<BeamResponse>(ENDPOINT.BEAM, {
      rebarStrength: payload.rebarStrength,
      spanLength: payload.beamSpan,
    }, 'beam')
  },
  requestCalcColumn (payload: ColumnInput) {
    return $POST<ColumnResponse>(ENDPOINT.COLUMN, {
      spanWidth: payload.longSideSpan,
      spanHeight: payload.shortSideSpan,
      useName: payload.usage, // ???
      useValue: USAGE[payload.usage],
      slabThickness: payload.slabThickness,
      floors: payload.stories,
      concStrength: payload.concreteStrength,
      criterionSize: payload.criterionSize,
    }, 'column')
  },
  requestCalcFoundation (payload: FoundationInput) {
    return $POST<FoundationResponse>(ENDPOINT.FOUNDATION, {
      spanWidth: payload.longSideSpan,
      spanHeight: payload.shortSideSpan,
      useName: payload.usage, // ???
      useValue: USAGE[payload.usage],
      slabThickness: payload.slabThickness,
      floors: payload.stories,
      floorHeight: payload.floorHeight,
      concStrength: payload.concreteStrength,
      bearingCapacity: payload.bearingCapacity,
      criterionSize: payload.criterionSize,
    }, 'foundation')
  },
  requestCalcBasementWall (payload: BasementWallInput) {
    payload.whetherCalc[0] = (payload.b1Height > 0) ? 1 : 0
    payload.whetherCalc[1] = (payload.b2Height > 0) ? 1 : 0
    payload.whetherCalc[2] = (payload.b3Height > 0) ? 1 : 0
    payload.whetherCalc[3] = (payload.b4Height > 0) ? 1 : 0
    payload.whetherCalc[4] = (payload.b5Height > 0) ? 1 : 0

    return $POST<BasementWallResponse>(ENDPOINT.BASEMENTWALL, {
      floorHeights: [
        payload.b1Height,
        payload.b2Height,
        payload.b3Height,
        payload.b4Height,
        payload.b5Height].map(Number),
      whetherCalc: payload.whetherCalc,
    }, 'basement-wall')
  },
  requestCalcWindTunnelStudy (payload: WindTunnelStudyInput) {
    return $POST<WindTunnelStudyResponse>(ENDPOINT.WINDTUNNELSTUDY, {
      outerArea: payload.outerArea,
      height: payload.height,
    }, 'wind-tunnel-study')
  },
}
